import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  extends: FontAwesomeIcon,
  props: {
    'aria-hidden': true,
  },
}
